import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, of, throwError } from 'rxjs';
import { AppConfig } from 'src/app/app.config';

@Injectable({ providedIn: 'root' })
export class AlfrescoService {
	alfrescoApiUrl: string;
	alfrescoServiceApiUrl: string;
	alfrescoCoreUrl = '/alfresco/versions/1';
	alfrescoAuthUrl = '/authentication/versions/1';
	alfrescoCmisUrl = '/cmis/versions/1.1/browser/root';
	alfrescoSearchUrl = '/search/versions/1';
	classeRadiceAlfresco: string;

	constructor(
		private appConfig: AppConfig,
		private http: HttpClient,
	) {
		this.alfrescoApiUrl = appConfig.get('alfrescoApiUrl');
		this.alfrescoServiceApiUrl = appConfig.get('alfrescoServiceApiUrl');
		this.classeRadiceAlfresco = appConfig.get('classeRadiceAlfresco');
	}

	login(userId: string, password: string) {
		return this.http.post(this.alfrescoApiUrl + this.alfrescoAuthUrl + '/tickets', { userId, password });
	}

	getUtenteLoggato() {
		return this.http.get(this.alfrescoApiUrl + this.alfrescoCoreUrl + '/people/-me-?include=properties');
	}

	getSiti() {
		return this.http.get(this.alfrescoApiUrl + this.alfrescoCoreUrl + '/sites');
	}

	getClassiDocumentali() {
		return this.http.get(this.alfrescoApiUrl + this.alfrescoCoreUrl + `/types?where=(parentId in ('${this.classeRadiceAlfresco}'))`);
	}

	getGruppiUtenteLoggato() {
		return this.http.get(this.alfrescoApiUrl + this.alfrescoCoreUrl + '/people/-me-/groups?maxItems=9999');
	}

	getUtentiSito(idSito: string) {
		return this.http.get(this.alfrescoApiUrl + this.alfrescoCoreUrl + `/sites/${idSito}/members?maxItems=9999`);
	}

	getClasseDocumentale(id: string) {
		return this.http.get(this.alfrescoApiUrl + this.alfrescoCoreUrl + `/types/${id}`);
	}

	getDataLists(idSito: string) {
		return this.http.get(this.alfrescoApiUrl + this.alfrescoCmisUrl + `/Sites/${idSito}/dataLists`).pipe(
			catchError((error: HttpErrorResponse) => {
				if (error.status === 404) {
					return of({ objects: [] });
				}
				return throwError(() => error);
			}),
		);
	}

	getDataList(idSito: string, idDatalist: string) {
		return this.http.get(this.alfrescoApiUrl + this.alfrescoCmisUrl + `/Sites/${idSito}/dataLists/${idDatalist}`);
	}

	search(body: any) {
		return this.http.post(this.alfrescoApiUrl + this.alfrescoSearchUrl + '/search', body);
	}

	getNode(id: string) {
		return this.http.get(this.alfrescoApiUrl + this.alfrescoCoreUrl + `/nodes/${id}`);
	}

	getNodeFromPath(path: string) {
		const body = {
			query: {
				query: "PATH:'/app:company_home/cm:" + path + "'",
			},
		};
		return this.search(body).pipe(map((res: any) => res.list.entries[0]));
	}

	uploadDocumento(idNodoPadre: string, file: File) {
		const formData = new FormData();
		formData.append('fileData', file, file.name);
		formData.append('autoRename', 'true');
		return this.http.post(this.alfrescoApiUrl + this.alfrescoCoreUrl + `/nodes/${idNodoPadre}/children`, formData);
	}

	updateNode(idNodo: string, body: any) {
		return this.http.put(this.alfrescoApiUrl + this.alfrescoCoreUrl + `/nodes/${idNodo}`, body);
	}

	updateNodeChildren(idNodo: string, body: any) {
		return this.http.post(this.alfrescoApiUrl + this.alfrescoCoreUrl + `/nodes/${idNodo}/children`, body);
	}

	addTag(idNodo: string, tag: string) {
		return this.http.post(this.alfrescoApiUrl + this.alfrescoCoreUrl + `/nodes/${idNodo}/tags`, { tag });
	}

	associaAllegato(idNodoPadre: string, idNodoAllegato: string) {
		return this.http.post(this.alfrescoApiUrl + this.alfrescoCoreUrl + `/nodes/${idNodoPadre}/targets`, {
			assocType: this.appConfig.get('idTipoAssociazioneAllegati'),
			targetId: idNodoAllegato,
		});
	}

	getAllegati(idNodo: string) {
		return this.http.get(this.alfrescoApiUrl + this.alfrescoCoreUrl + `/nodes/${idNodo}/targets?include=properties`);
	}

	getDownloadUrl(idNodo: string, scaricaComeAllegato: boolean): string {
		const ticket = localStorage.getItem('alfresco-ticket');
		return `${this.alfrescoApiUrl}${this.alfrescoCoreUrl}/nodes/${idNodo}/content?attachment=${scaricaComeAllegato}&alf_ticket=${ticket}`;
	}

	getVersioniNodo(idNodo: string) {
		return this.http.get(this.alfrescoApiUrl + this.alfrescoCoreUrl + `/nodes/${idNodo}/versions`);
	}

	getDownloadUrlVersione(idNodo: string, idVersione: string, scaricaComeAllegato: boolean): string {
		const ticket = localStorage.getItem('alfresco-ticket');
		return `${this.alfrescoApiUrl}${this.alfrescoCoreUrl}/nodes/${idNodo}/versions/${idVersione}/content?attachment=${scaricaComeAllegato}&alf_ticket=${ticket}`;
	}

	richiediResetPassword(idUtente: string) {
		const body = '{  "client": "share" }';
		return this.http.post(this.alfrescoApiUrl + this.alfrescoCoreUrl + `/people/${idUtente}/request-password-reset`, body);
	}

	resetPassword(idUtente: string, body: any) {
		return this.http.post(this.alfrescoApiUrl + this.alfrescoCoreUrl + `/people/${idUtente}/reset-password`, body);
	}

	updateUtente(idUtente: string, body: any) {
		return this.http.put(this.alfrescoApiUrl + this.alfrescoCoreUrl + `/people/${idUtente}`, body);
	}
}
